import ReceiptrexCutie from "@/assets/receiptrex-cutie.svg";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

export function NotFound() {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
            <img
                src={ReceiptrexCutie}
                alt="ReceiptRex Cutie"
                className="w-128 h-128 mb-0"
            />
            <h1 className="text-5xl font-semibold text-gray-800 mb-4">
                Oops! Receipt not found
            </h1>

            <p className="text-gray-600 mb-8 max-w-md">
                The receipt you're looking for seems to have wandered off. Even
                Receiptrex can't find it!
            </p>
            <Button>
                <Link to="/">Back to Home</Link>
            </Button>
        </div>
    );
}
